import React, { createContext, useEffect, useState } from "react";
import { getPublicPath, isNullOrEmpty } from "../utils";
import { jwtDecode } from "jwt-decode";
import moment from "moment";
import { setAxiosInstance } from "../api/httpClient";

export const AuthContext = createContext(undefined);

export const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState({});
  const login = (data) => {
    localStorage.setItem('student-token', JSON.stringify(data));
    setUserData({...data, isLoggedIn: true});
  }
  const logout = () => {
    localStorage.removeItem("student-token");
    setUserData({});
    window.location.href = getPublicPath() ? `/${getPublicPath()}` : '/';
  }
  useEffect(() => {
    const tokenStringified = localStorage.getItem("student-token");
    if (isNullOrEmpty(tokenStringified)) {
      return
    }
    const token = JSON.parse(tokenStringified);
    if (isNullOrEmpty(token) || isNullOrEmpty(token.token)) {
      return
    }
    const decoded = jwtDecode(token.token);
    const currentUnixTime = moment().unix();
    // Add 10 minute (600 seconds) buffer to expiration check
    if (decoded.exp < currentUnixTime + 600) {
      logout();
    }
    setUserData({...token, isLoggedIn: true});
  }, []);
  useEffect(() =>  {
    if (isNullOrEmpty(userData.token)) {
      return;
    }
    setAxiosInstance({
      Authorization: userData.token
    })
  }, [userData.token])
  return (
    <AuthContext.Provider value={{ userData, setUserData, logout, login }}>
      {children}
    </AuthContext.Provider>
  );
};
